export enum RegistrationStatusEnum {
    CANCELLED = 'CANCELLED',
    PREREGISTERED = 'PREREGISTERED',
    PREREGISTERED_CANCELLED = 'PREREGISTERED_CANCELLED',
    PREREGISTERED_DRAW_KO = 'PREREGISTERED_DRAW_KO',
    PREREGISTERED_DRAW_OK = 'PREREGISTERED_DRAW_OK',
    PREREGISTERED_DRAW_OK_CANCELLED = 'PREREGISTERED_DRAW_OK_CANCELLED',
    PREREGISTERED_WAITING = 'PREREGISTERED_WAITING',
    REGISTERED = 'REGISTERED',
    TRANSFERRED = 'TRANSFERRED',
}
